"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var object_schema_1 = __importDefault(require("./object.schema"));
exports["default"] = object_schema_1["default"];
//# sourceMappingURL=index.js.map